module.exports = __webpack_public_path__ + "static/media/info_delivery.fe4b3f4d.png";